import http from "@http"
// 人员信息管理接口
// 用户列表 全部
export function queryUserAll(data) {
    return http({
        url: '/lskj-admin/api/admin/user/all',
        method: "post",
        data
    })
}
// 用户列表 分页
export function queryUserList(data) {
    return http({
        url: '/lskj-admin/api/admin/user/list',
        method: "post",
        data
    })
}
// 单条用户信息
export function queryUserById(data) {
    return http({
        url: `/lskj-admin/api/admin/user/byId?id=${data.id}`,
        method: "get",
    })
}
// 添加用户
export function userAdd(data) {
    return http({
        url: '/lskj-admin/api/admin/user/add',
        method: "post",
        data
    })
}
//修改用户信息
export function updeteUser(data) {
    return http({
        url: `/lskj-admin/api/admin/user`,
        method: "put",
        data
    })
}
//修改用户密码
export function updatePass(data) {
    return http({
        url: `/lskj-admin/api/admin/user/updatePass`,
        method: "put",
        data
    })
}
//删除用户信息
export function deleteUser(data) {
    return http({
        url: `/lskj-admin/api/admin/user?ids=${data.ids}`,
        method: "delete",
        data
    })
}


//获取用户信息
export function getUserInfo() {
    return http({
        url: `/lskj-admin/api/admin/user/getUserInfo`,
        method: "get",
    }) 
}